module.exports = __webpack_public_path__ + "static/media/Travel.7aa83908.svg";